import type {
	getUserSettingsInput,
	updateUserSettingsInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetUserSettings: getUserSettingsInput;
	useUpdateUserSettings: updateUserSettingsInput;
}

const SETTINGS_SERVICE_KEYS = createReactQueryKeys<Keys>("settings", [
	"useGetUserSettings",
	"useUpdateUserSettings",
]);

export { SETTINGS_SERVICE_KEYS };
